export const formatTimeFromMilliseconds = (time: number) => {
  const pad = (n: number) => {
    return ('00' + n).slice(-2);
  };
  const ms = time % 1000;
  time = (time - ms) / 1000;
  const secs = time % 60;
  time = (time - secs) / 60;
  const mins = time % 60;
  time = (time - mins) / 60;
  const hours = time;
  if (hours > 0) {
    return pad(hours) + ':' + pad(mins) + ':' + pad(secs);
  }
  return pad(mins) + ':' + pad(secs);
};

export const formatTimeFromSeconds = (time: number) => {
  return formatTimeFromMilliseconds(time * 1000);
};

// helper function to format duration by removing leading zero from hours
export const formatPodcastEpisodeDuration = (duration: string): string => {
  if (!duration) {
    return '';
  }

  // check if duration is in HH:MM:SS format and starts with "0"
  const timeMatch = duration.match(/^0(\d:\d{2}:\d{2})$/);
  if (timeMatch) {
    return timeMatch[1];
  }

  return duration;
};
